import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
const AdminContext = createContext();
const dummyNotifications = [
  {
    id: 1,
    title: 'New Package Booking Received',
    message: 'Ali Khan has booked "Hunza Valley Adventure - 7 Days" package for 4 people. Total amount: PKR 180,000',
    type: 'booking',
    icon: '📦',
    color: '#4A9E8E',
    isUnread: true,
    createdAt: new Date(Date.now() - 5 * 60000),
    relatedEntityId: 'BK-2234',
    relatedEntityName: 'Hunza Valley Adventure'
  },
  {
    id: 2,
    title: 'Payment Received',
    message: 'Payment of PKR 150,000 has been successfully received for booking #BK-2345 from Sara Ahmed.',
    type: 'payment',
    icon: '💰',
    color: '#FFB800',
    isUnread: true,
    createdAt: new Date(Date.now() - 60 * 60000),
    relatedEntityId: 'PAY-5678',
    relatedEntityName: 'Booking #BK-2345'
  },
  {
    id: 3,
    title: 'New Hotel Booking',
    message: 'Ahmed Khan has booked Pearl Continental Hotel, Room 101 for 2 nights (Feb 20 - Feb 22, 2026).',
    type: 'booking',
    icon: '🏨',
    color: '#2C5F7C',
    isUnread: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60000),
    relatedEntityId: 'HB-789',
    relatedEntityName: 'Pearl Continental'
  },
  {
    id: 4,
    title: 'New Vendor Registration',
    message: 'Mountain Travels & Tours has registered as a new vendor and is awaiting approval.',
    type: 'vendor',
    icon: '🏢',
    color: '#9C27B0',
    isUnread: true,
    createdAt: new Date(Date.now() - 5 * 60 * 60000),
    relatedEntityId: 'VND-456',
    relatedEntityName: 'Mountain Travels & Tours'
  },
  {
    id: 5,
    title: 'Payment Failed - Action Required',
    message: 'Payment attempt failed for hotel booking #HB-6789. Customer has been notified automatically.',
    type: 'payment',
    icon: '⚠️',
    color: '#DC3545',
    isUnread: true,
    createdAt: new Date(Date.now() - 24 * 60 * 60000),
    relatedEntityId: 'HB-6789',
    relatedEntityName: 'Hotel Booking #HB-6789'
  },
  {
    id: 6,
    title: 'Low Rating Alert',
    message: 'Adventure Tours received a 2-star review from Ayesha Khan. Review requires attention.',
    type: 'review',
    icon: '⭐',
    color: '#FF6B6B',
    isUnread: false,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60000),
    relatedEntityId: 'REV-123',
    relatedEntityName: 'Adventure Tours'
  },
  {
    id: 7,
    title: 'System Maintenance Scheduled',
    message: 'Scheduled system maintenance on Jan 25, 2026 at 2:00 AM PKT. Expected downtime: 2 hours.',
    type: 'system',
    icon: '⚙️',
    color: '#6C757D',
    isUnread: false,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000),
    relatedEntityId: null,
    relatedEntityName: 'System'
  },
  {
    id: 8,
    title: 'Booking Cancellation Request',
    message: 'Usman Ali has requested cancellation for booking #BK-1122 - Skardu Adventure Tour.',
    type: 'booking',
    icon: '❌',
    color: '#FF8C00',
    isUnread: true,
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60000),
    relatedEntityId: 'BK-1122',
    relatedEntityName: 'Skardu Adventure'
  },
  {
    id: 9,
    title: 'Refund Processed',
    message: 'Refund of PKR 50,000 has been successfully processed for cancelled booking #BK-8899.',
    type: 'payment',
    icon: '💳',
    color: '#28A745',
    isUnread: false,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60000),
    relatedEntityId: 'REF-334',
    relatedEntityName: 'Booking #BK-8899'
  },
  {
    id: 10,
    title: '5-Star Review Received',
    message: 'Fatima Sheikh gave excellent feedback for "Naran Kaghan Package". Great job team!',
    type: 'review',
    icon: '🌟',
    color: '#FFD700',
    isUnread: false,
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60000),
    relatedEntityId: 'REV-456',
    relatedEntityName: 'Naran Kaghan Package'
  },
  {
    id: 11,
    title: 'New Customer Registration',
    message: 'New customer Bilal Ahmed has registered and completed profile verification.',
    type: 'system',
    icon: '👤',
    color: '#17A2B8',
    isUnread: true,
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60000),
    relatedEntityId: 'USR-789',
    relatedEntityName: 'Bilal Ahmed'
  },
  {
    id: 12,
    title: 'Package Updated',
    message: 'Vendor "Serena Hotels" has updated pricing for "Islamabad City Tour" package.',
    type: 'vendor',
    icon: '📝',
    color: '#6F42C1',
    isUnread: false,
    createdAt: new Date(Date.now() - 8 * 24 * 60 * 60000),
    relatedEntityId: 'PKG-991',
    relatedEntityName: 'Islamabad City Tour'
  }
];

// Helper function to calculate stats
const calculateStats = (notifications) => {
  return {
    total: notifications.length,
    unread: notifications.filter(n => n.isUnread).length,
    read: notifications.filter(n => !n.isUnread).length
  };
};

export const useNotifications = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useNotifications must be used within SidebarProvider');
  return {
    notifications: context.notifications,
    filterType: context.notificationFilterType,
    setFilterType: context.setNotificationFilterType,
    stats: context.notificationStats,
    loading: context.notificationLoading,
    markAsRead: context.markNotificationAsRead,
    markAllAsRead: context.markAllNotificationsAsRead,
    deleteNotification: context.deleteNotification,
    clearAllNotifications: context.clearAllNotifications,
    getFilteredNotifications: context.getFilteredNotifications
  };
};

export const useSidebar = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useSidebar must be used within AdminProvider');
  return context;
};

export const useBooking = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useBooking must be used within AdminProvider');
  return {
    bookings: context.bookings,
    bookingFilters: context.bookingFilters,
    bookingStats: context.bookingStats,
    selectedBooking: context.selectedBooking,
    showBookingDetailsModal: context.showBookingDetailsModal,
    loading: context.bookingLoading,
    setBookings: context.setBookings,
    setBookingFilters: context.setBookingFilters,
    setSelectedBooking: context.setSelectedBooking,
    setShowBookingDetailsModal: context.setShowBookingDetailsModal,
    fetchBookings: context.fetchBookings,
    updateBookingStatus: context.updateBookingStatus,
    exportBookingReport: context.exportBookingReport,
    getFilteredBookings: context.getFilteredBookings,
  };
};

export const useAdminUser = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useAdminUser must be used within AdminProvider');
  return context;
};

export const useVendors = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useVendors must be used within AdminProvider');
  return {
    vendors: context.vendors,
    selectedVendor: context.selectedVendor,
    vendorStats: context.vendorStats,
    filters: context.vendorFilters,
    showModal: context.vendorShowModal,
    setVendors: context.setVendors,
    setSelectedVendor: context.setSelectedVendor,
    setVendorStats: context.setVendorStats,
    setFilters: context.setVendorFilters,
    setShowModal: context.setVendorShowModal,
    updateVendor: context.updateVendor,
    deleteVendor: context.deleteVendor,
  };
};

export const SidebarProvider = ({ children }) => {
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [expandedMenus, setExpandedMenus] = useState([]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleMenuExpansion = (menuId) => {
    setExpandedMenus((prev) =>
      prev.includes(menuId) ? prev.filter((id) => id !== menuId) : [...prev, menuId]
    );
  };
  const setActiveMenuItem = (menuId) => setActiveMenu(menuId);
  const isMenuExpanded = (menuId) => expandedMenus.includes(menuId);

  const [notifications, setNotifications] = useState([]);
  const [notificationFilterType, setNotificationFilterType] = useState('all'); // 'all' | 'unread' | 'read'
  const [notificationLoading, setNotificationLoading] = useState(false);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    setNotificationLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      setNotifications(dummyNotifications);
    } catch (error) {
      console.error('Error loading notifications:', error);
    } finally {
      setNotificationLoading(false);
    }
  };

  const notificationStats = calculateStats(notifications);

  const getFilteredNotifications = useCallback(() => {
    if (notificationFilterType === 'all') {
      return notifications;
    } else if (notificationFilterType === 'unread') {
      return notifications.filter(n => n.isUnread);
    } else if (notificationFilterType === 'read') {
      return notifications.filter(n => !n.isUnread);
    }
    return notifications;
  }, [notifications, notificationFilterType]);

  const markNotificationAsRead = useCallback((notificationId) => {
    setNotifications(prev => 
      prev.map(n => n.id === notificationId ? { ...n, isUnread: false } : n)
    );
  }, []);

  const markAllNotificationsAsRead = useCallback(() => {
    setNotifications(prev => 
      prev.map(n => ({ ...n, isUnread: false }))
    );
  }, []);

  const deleteNotification = useCallback((notificationId) => {
    setNotifications(prev => prev.filter(n => n.id !== notificationId));
  }, []);

  const clearAllNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendorStats, setVendorStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    blocked: 0,
  });
  const [vendorFilters, setVendorFilters] = useState({
    search: '',
    status: 'all',
    rating: 'all',
    location: 'all',
    joinedDate: 'all',
  });
  const [vendorShowModal, setVendorShowModal] = useState(false);

  const updateVendor = useCallback((id, updates) => {
    setVendors((prev) => prev.map((v) => (v.id === id ? { ...v, ...updates } : v)));
  }, []);

  const deleteVendor = useCallback((id) => {
    setVendors((prev) => prev.filter((v) => v.id !== id));
  }, []);

  const [admUserActiveTab, setAdmUserActiveTab] = useState('all');
  const [admUserFilters, setAdmUserFilters] = useState({
    search: '',
    status: 'all'
  });
  const [admUsersData, setAdmUsersData] = useState([]);
  const [admUserSelected, setAdmUserSelected] = useState(null);
  const [admUserModals, setAdmUserModals] = useState({
    showDetails: false,
    showAddAdmin: false,
    showBlockConfirm: false
  });
  const [admUserToast, setAdmUserToast] = useState({
    show: false,
    message: '',
    type: 'success'
  });

  const admUserSetData = useCallback((users) => setAdmUsersData(users), []);
  const admUserAddToData = useCallback((newUser) => {
    setAdmUsersData(prev => [...prev, newUser]);
  }, []);
  const admUserUpdateInData = useCallback((userId, updates) => {
    setAdmUsersData(prev => prev.map(u => u.id === userId ? { ...u, ...updates } : u));
  }, []);
  const admUserRemoveFromData = useCallback((userId) => {
    setAdmUsersData(prev => prev.filter(u => u.id !== userId));
  }, []);

  const admUserGetFiltered = useCallback(() => {
    let filtered = admUsersData;
    if (admUserActiveTab === 'customers') {
      filtered = filtered.filter(u => u.role === 'customer');
    } else if (admUserActiveTab === 'vendors') {
      filtered = filtered.filter(u => u.role === 'vendor');
    } else if (admUserActiveTab === 'admins') {
      filtered = filtered.filter(u => u.role === 'admin');
    }
    if (admUserFilters.search) {
      const query = admUserFilters.search.toLowerCase();
      filtered = filtered.filter(u =>
        u.name?.toLowerCase().includes(query) ||
        u.email?.toLowerCase().includes(query) ||
        u.phone?.includes(query)
      );
    }
    if (admUserFilters.status !== 'all') {
      filtered = filtered.filter(u => u.status === admUserFilters.status);
    }
    return filtered;
  }, [admUsersData, admUserActiveTab, admUserFilters]);

  const admUserGetStats = useCallback(() => {
    const roleFilter = admUserActiveTab === 'all' ? null : 
      admUserActiveTab === 'customers' ? 'customer' :
      admUserActiveTab === 'vendors' ? 'vendor' : 'admin';
    const users = roleFilter ? admUsersData.filter(u => u.role === roleFilter) : admUsersData;

    if (admUserActiveTab === 'all') {
      return {
        totalUsers: users.length,
        activeUsers: users.filter(u => u.status === 'active').length,
        pendingUsers: users.filter(u => u.status === 'pending').length,
        suspendedUsers: users.filter(u => u.status === 'suspended' || u.status === 'blocked').length
      };
    } else if (admUserActiveTab === 'customers') {
      return {
        totalCustomers: users.length,
        activeCustomers: users.filter(u => u.status === 'active').length,
        inactiveCustomers: users.filter(u => u.status === 'inactive').length,
        blockedCustomers: users.filter(u => u.status === 'blocked').length
      };
    } else if (admUserActiveTab === 'vendors') {
      return {
        totalVendors: users.length,
        activeVendors: users.filter(u => u.status === 'active').length,
        inactiveVendors: users.filter(u => u.status === 'inactive').length,
        pendingVendors: users.filter(u => u.status === 'pending').length,
        approvedVendors: users.filter(u => u.status === 'active' && u.verified).length,
        blockedVendors: users.filter(u => u.status === 'blocked' || u.status === 'suspended').length
      };
    } else if (admUserActiveTab === 'admins') {
      return {
        totalAdmins: users.length,
        activeAdmins: users.filter(u => u.status === 'active').length,
        inactiveAdmins: users.filter(u => u.status === 'inactive').length
      };
    }
  }, [admUsersData, admUserActiveTab]);

  const admUserUpdateFilter = useCallback((key, value) => {
    setAdmUserFilters(prev => ({ ...prev, [key]: value }));
  }, []);
  const admUserResetFilters = useCallback(() => {
    setAdmUserFilters({ search: '', status: 'all' });
  }, []);
  const admUserToggleModal = useCallback((modal, state, user = null) => {
    setAdmUserModals(prev => ({ ...prev, [modal]: state }));
    if (user) setAdmUserSelected(user);
  }, []);
  const admUserShowToast = useCallback((message, type = 'success') => {
    setAdmUserToast({ show: true, message, type });
    setTimeout(() => setAdmUserToast({ show: false, message: '', type: 'success' }), 3000);
  }, []);

  // ========== BOOKING MANAGEMENT STATE ==========
  const [bookings, setBookings] = useState([
    {
      id: 'BK001',
      hotelName: 'Pearl Continental Karachi',
      vendorName: 'Hashoo Group',
      vendorId: 'V001',
      userName: 'Ahmed Khan',
      userEmail: 'ahmed@example.com',
      userPhone: '+92 300 1234567',
      checkIn: '2026-02-15',
      checkOut: '2026-02-18',
      rooms: 2,
      nights: 3,
      roomType: 'Deluxe Suite',
      guests: 4,
      totalAmount: 75000,
      bookingStatus: 'confirmed',
      paymentStatus: 'paid',
      paymentMethod: 'Credit Card',
      commission: 7500,
      vendorPayout: 67500,
      createdAt: '2026-01-15T10:30:00',
      specialRequests: 'Late check-in required'
    },
    {
      id: 'BK002',
      hotelName: 'Serena Hotel Islamabad',
      vendorName: 'Serena Hotels',
      vendorId: 'V002',
      userName: 'Sara Ali',
      userEmail: 'sara@example.com',
      userPhone: '+92 321 9876543',
      checkIn: '2026-03-10',
      checkOut: '2026-03-12',
      rooms: 1,
      nights: 2,
      roomType: 'Executive Room',
      guests: 2,
      totalAmount: 45000,
      bookingStatus: 'pending',
      paymentStatus: 'pending',
      paymentMethod: 'Bank Transfer',
      commission: 4500,
      vendorPayout: 40500,
      createdAt: '2026-01-20T14:15:00',
      specialRequests: 'Non-smoking room'
    },
    {
      id: 'BK003',
      hotelName: 'Marriott Hotel Lahore',
      vendorName: 'Marriott International',
      vendorId: 'V003',
      userName: 'Bilal Ahmed',
      userEmail: 'bilal@example.com',
      userPhone: '+92 333 4567890',
      checkIn: '2026-01-25',
      checkOut: '2026-01-28',
      rooms: 3,
      nights: 3,
      roomType: 'Family Suite',
      guests: 6,
      totalAmount: 120000,
      bookingStatus: 'completed',
      paymentStatus: 'paid',
      paymentMethod: 'Credit Card',
      commission: 12000,
      vendorPayout: 108000,
      createdAt: '2026-01-05T09:45:00',
      specialRequests: 'Extra beds required'
    }
  ]);

  const [bookingFilters, setBookingFilters] = useState({
    dateRange: { start: '', end: '' },
    hotel: '',
    vendor: '',
    bookingStatus: '',
    paymentStatus: '',
    searchQuery: ''
  });

  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showBookingDetailsModal, setShowBookingDetailsModal] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);

  const bookingStats = {
    total: bookings.length,
    pending: bookings.filter(b => b.bookingStatus === 'pending').length,
    confirmed: bookings.filter(b => b.bookingStatus === 'confirmed').length,
    completed: bookings.filter(b => b.bookingStatus === 'completed').length,
    cancelled: bookings.filter(b => b.bookingStatus === 'cancelled').length,
    totalRevenue: bookings.reduce((sum, b) => 
      sum + (b.bookingStatus !== 'cancelled' ? b.totalAmount : 0), 0
    ),
    totalCommission: bookings.reduce((sum, b) => sum + b.commission, 0)
  };

  const fetchBookings = async (params = {}) => {
    setBookingLoading(true);
    try {
      console.log('Fetching bookings with params:', params);
    } catch (error) {
      console.error('Error fetching bookings:', error);
    } finally {
      setBookingLoading(false);
    }
  };

  const updateBookingStatus = async (bookingId, newStatus, reason = null) => {
    try {
      setBookings(prevBookings =>
        prevBookings.map(booking =>
          booking.id === bookingId
            ? {
                ...booking,
                bookingStatus: newStatus,
                ...(newStatus === 'cancelled' && {
                  cancellationReason: reason,
                  cancelledAt: new Date().toISOString(),
                  paymentStatus: 'refunded'
                })
              }
            : booking
        )
      );
      console.log(`Booking ${bookingId} updated to ${newStatus}`);
    } catch (error) {
      console.error('Error updating booking:', error);
    }
  };

  const exportBookingReport = async (format = 'pdf') => {
    try {
      console.log(`Exporting ${format} report...`);
    } catch (error) {
      console.error('Error exporting report:', error);
    }
  };

  const getFilteredBookings = useCallback(() => {
    let filtered = [...bookings];

    if (bookingFilters.searchQuery) {
      const query = bookingFilters.searchQuery.toLowerCase();
      filtered = filtered.filter(b =>
        b.id.toLowerCase().includes(query) ||
        b.hotelName.toLowerCase().includes(query) ||
        b.userName.toLowerCase().includes(query) ||
        b.userEmail.toLowerCase().includes(query)
      );
    }

    if (bookingFilters.bookingStatus) {
      filtered = filtered.filter(b => b.bookingStatus === bookingFilters.bookingStatus);
    }

    if (bookingFilters.paymentStatus) {
      filtered = filtered.filter(b => b.paymentStatus === bookingFilters.paymentStatus);
    }

    if (bookingFilters.hotel) {
      filtered = filtered.filter(b => b.hotelName === bookingFilters.hotel);
    }

    if (bookingFilters.vendor) {
      filtered = filtered.filter(b => b.vendorName === bookingFilters.vendor);
    }

    if (bookingFilters.dateRange.start && bookingFilters.dateRange.end) {
      filtered = filtered.filter(b => {
        const checkInDate = new Date(b.checkIn);
        const startDate = new Date(bookingFilters.dateRange.start);
        const endDate = new Date(bookingFilters.dateRange.end);
        return checkInDate >= startDate && checkInDate <= endDate;
      });
    }

    return filtered;
  }, [bookings, bookingFilters]);

  const value = {
    isSidebarOpen, toggleSidebar, activeMenu, setActiveMenuItem, expandedMenus, toggleMenuExpansion, isMenuExpanded,
    notifications,
    notificationFilterType,
    setNotificationFilterType,
    notificationStats,
    notificationLoading,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    deleteNotification,
    clearAllNotifications,
    getFilteredNotifications,
    
    vendors, setVendors, selectedVendor, setSelectedVendor, vendorStats, setVendorStats,
    vendorFilters, setVendorFilters, vendorShowModal, setVendorShowModal, updateVendor, deleteVendor,
    
    admUsersData, admUserSetData, admUserAddToData, admUserUpdateInData, admUserRemoveFromData,
    admUserActiveTab, setAdmUserActiveTab, admUserFilters, admUserUpdateFilter, admUserResetFilters,
    admUserSelected, setAdmUserSelected, admUserModals, admUserToggleModal, admUserToast, admUserShowToast,
    admUserGetFiltered, admUserGetStats,
    
    bookings, setBookings,
    bookingFilters, setBookingFilters,
    bookingStats,
    selectedBooking, setSelectedBooking,
    showBookingDetailsModal, setShowBookingDetailsModal,
    bookingLoading,
    fetchBookings,
    updateBookingStatus,
    exportBookingReport,
    getFilteredBookings,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export default AdminContext;